module.exports = __webpack_public_path__ + "static/img/14.6849651.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/14.png
// module id = 8YhY
// module chunks = 0